// extracted by mini-css-extract-plugin
export default {"pageBody":"index_pageBody_QmSzR","pageBottom":"index_pageBottom_031My","botton":"index_botton_8tzeP"};